
export default {
    name: 'NotFound'
}
